export enum SequenceStatusEnum {
  Draft = 'draft',
  Active = 'active',
  Trash = 'trash',
  FinishedAndWaiting = 'finishedAndWaiting',
  Finished = 'finished'
}
